import type { CategoryAttributes } from '../services';
import type { ICategory } from '../types';

const categoryListTransformer = (categoryData: CategoryAttributes, language = 'en-us'): ICategory => {
  const { attribs: { [language]: data } = {} } = categoryData || {};
  const {
    name: title = '',
    bannerImage: { publicUrl: imageLink = '', altText: imageAlt = '' } = {},
    bannerCssCode = '',
    description = '',
  } = data || {};
  return {
    title,
    imageLink,
    imageAlt,
    bannerCssCode,
    description,
  };
};

export { categoryListTransformer };
